<template>
  <div class="skill_group_monitor" :style="screenHeight">
    <Spin size="large" fix v-if="spinShow"><Icon type="ios-loading" size=18 class="demo-spin-icon-load"></Icon><div>正在加载中...</div></Spin>
    <div class="demo-split">
        <div class="demo-split-pane" style="float:left;border-right:1px solid #eeeeee;width:30%">
          <div class="ztree" id="seatTree"></div>
        </div>
        <div class="demo-split-pane" style="float:right;width:70%">
          <div id="showDashboard" style="width: 100%;height: 40%;"></div>
          <div class="fixed_table" style="height: 60%">
            <div class="monitor_time">
              <Select v-model="agentStatus" filterable clearable placeholder="请选择员工状态进行查询"  @on-change="searchAgentStatus" title="员工状态查询" style="float: left">
                <Option v-for="item in agentStatusList" :value="item.id" :key="item.id">{{ item.name }}</Option>
              </Select>
              <Select v-model="autoRefreshTime" @on-change="autoRefreshMonitor" title="自动刷新时间">
                <Option v-for="item in autoRefreshList" :value="item.time" :key="item.time">{{ item.name }}</Option>
              </Select>
              <span style="color: red;float: right;margin-right: 10px" title="刷新倒计时">{{countdownTime}}</span>
            </div>
            <div class="public_btn" style="height: 44px;">
              <Button class="search_btn template_btn" :disabled="force_offline" @click="operateMonitor('force_offline')">强制下线</Button>
              <Button class="search_btn template_btn" :disabled="force_busy" @click="operateMonitor('force_busy')">强制置忙</Button>
              <Button class="search_btn template_btn" :disabled="force_idle" @click="operateMonitor('force_idle')">强制置闲</Button>
              <Button class="search_btn template_btn" :disabled="force_hangup" @click="operateMonitor('force_hangup')">强 拆</Button>
              <Button class="search_btn template_btn" :disabled="bargein" @click="operateMonitor('bargein')">强 插</Button>
              <Button class="search_btn template_btn" :disabled="whisper" @click="operateMonitor('whisper')">密 语</Button>
              <Button class="search_btn template_btn" :disabled="eavesdrop"  @click="operateMonitor('eavesdrop')">监 听</Button>
            </div>
            <div class="table_head">
              <table>
                <tr>
                  <th class="font_style_set" style="width:5%;">状态</th>
                  <th class="font_style_set" style="width:15%;">员工工号</th>
                  <th class="font_style_set" style="width:15%;">员工姓名</th>
                  <th class="font_style_set" style="width:10%;">时长</th>
                  <th class="font_style_set" style="width:10%;">部门</th>
                </tr>
              </table>
            </div>
            <div class="footer_style" :style="tableHeight">
              <table class="table_head_footer">
                <tr v-for="(item , index) in infoTableList" :key="index" :id="item.id" :class="{back_color:(index+1)%2==0}" @click="setSelected(item.id,item.agentNum,item.status)">
                  <td  style="width:5%;">{{item.status}}</td>
                  <td  style="width:15%;">{{item.agentNum}}</td>
                  <td  style="width:15%;">{{item.employeeName}}</td>
                  <td  style="width:10%;">{{item.time}}<span v-if="item.status!='离线'">秒</span></td>
                  <td  style="width:10%;">{{item.deptName}}</td>
                </tr>
              </table>
            </div>
          </div>
        </div>
    </div>
  </div>
</template>

<script>
  import {publicFunClass} from '@/components/js/PublicFunClass.js'
  export default {
    name: "SeatMonitor",
    mixins:[publicFunClass],
    props:{
      pageCode:String
    },
    data(){
      return {
        countdownTime:0,
        showPageCount:0,
        force_offline:true,
        force_busy:true,
        force_idle:true,
        force_hangup:true,
        bargein:true,
        whisper:true,
        eavesdrop:true,
        split: 0.3,
        split1: 0.5,
        spinShow:false,
        queueNumber:'',
        Interval:'',
        inspectTreeData:[{"id":0,"pId":0,"name":"部门","open":true,"isParent":true,"busid":"-1"},{"id":-1,"pId":-1,"name":"技能组","open":true,"isParent":true,"busid":"-1"}],
        fatherId:0,
        tableHeight:{height:''},
        deptList:'',
        skillList:'',
        screenHeight:{height:''},
        agentStatus:'',
        agentStatusList:[{'id': '-1', 'name': '离线'},{'id': '0', 'name': '空闲'},{'id': '1', 'name': '振铃'},{'id': '2', 'name': '通话中'},{'id': '3', 'name': '保持'},{'id': '4', 'name': '后处理'},{'id': '5', 'name': '被占用'},{'id': '6', 'name': '忙碌'},{'id': '7', 'name': '离开'},{'id': '8', 'name': '仅呼出'}],
        infoTableList:[],
        allTableList:[],
        roleList:JSON.parse(localStorage.getItem("roleList")),
        configInfo: JSON.parse(localStorage.getItem("configInfo")),
        currentBusid:'',
        timeMount:'',
        selectedNum:'',
        deptNameList:[],
        loginName:localStorage.getItem("loginName"),
        deptListInit:[],
        queueListInit:[]
      }
    },
    methods:{
      getTime:function(){
        clearInterval(this.timeMount);
        for (let k=0;k<this.allTableList.length;k++){
          let status=this.allTableList[k].status;
          if(status!="离线"){
            this.allTableList[k].time=this.allTableList[k].time+1;
          }
        }
        this.timeMount= setInterval(() =>{
          this.getTime();
        },1000);
      },
      setSelected:function(id,agentNum,status){
        if(id!="00"){
          this.selectedNum=agentNum;
        }
        for(let i=0;i<this.infoTableList.length;i++){
          let tableId=this.infoTableList[i].id;
          if(document.getElementById(tableId)){
             document.getElementById(tableId).style.backgroundColor="";
          }
        }
        if(document.getElementById(id)){
          document.getElementById(id).style.backgroundColor="#57a3f3";
        }
        this.force_offline=true;
        this.force_busy=true;
        this.force_idle=true;
        this.force_hangup=true;
        this.bargein=true;
        this.whisper=true;
        this.eavesdrop=true;
        if(status=="空闲"){
          this.force_offline=false;
          this.force_busy=false;
        }
        if(status=="通话中"){
          this.eavesdrop=false;
          this.whisper=false;
          this.bargein=false;
          this.force_hangup=false;
        }
        if(status=="忙碌"){
          this.force_idle=false;
          this.force_offline=false;
        }
        if(status=="仅呼出" || status=="后处理" || status=="仅呼出" || status=="离开"){
          this.force_idle=false;
        }
      },
      operateMonitor:function(eventMethod){
        this.$emit("getSeat",eventMethod,"callee",this.selectedNum);
      },
      autoRefresh:function(){
        let that=this;
        if(!this.currentBusid){
          // this.autoRefreshTime="0";
          this.$Message.info("请选择左侧目录中要刷新的技能组或部门的数据");
          return false;
        }
        let signinStatus=localStorage.getItem("signinStatus");
        if(signinStatus=='0'){
          this.$Message.info("请先签入,再查询数据");
          return false;
        }
        this.$emit("getSeat","get_agents_monitor_info","queueNumLstStr",that.currentBusid);
      },
      searchAgentStatus:function(){
        if(!this.agentStatus){
          this.infoTableList=this.allTableList;
          return false;
        }
        this.infoTableList=[];
        for (let i=0;i<this.allTableList.length;i++){
          if(this.agentStatus==this.allTableList[i].statusId){
            this.infoTableList.push(this.allTableList[i]);
          }
        }
      },
      initSearch:function (event) {
        let infoTableList=[];
        let allTableList=[];
        let signinStatus=localStorage.getItem("signinStatus");
        if(signinStatus=='0'){
          return false;
        }
        if(!event){
          return false;
        }
        let agentNames = event.agentname.split(",");
        let agentNums = event.agentnum.split(",");
        let agentGroupNums = event.agentgroupnum.split(",");
        let agentStatus = event.agentstatus.split(",");
        let statusChangeTime = event.statuschangetime.split(",");
        if(agentStatus.length > 0){
          let sortData = this.sortStatus(agentNames,agentNums,agentGroupNums,agentStatus,statusChangeTime);
          agentNames = sortData[0];
          agentNums = sortData[1];
          agentGroupNums = sortData[2];
          agentStatus = sortData[3];
          statusChangeTime = sortData[4];
          for (let i=0;i<agentNums.length;i++){
            let status="";
            for (let k=0;k<this.agentStatusList.length;k++){
              if(agentStatus[i]==this.agentStatusList[k].id){
                status=this.agentStatusList[k].name;
              }
            }
            let deptName="未知";
            if(this.deptNameList){
              for (let n=0;n<this.deptNameList.length;n++){
                if(this.deptNameList[n].id==agentGroupNums[i]){
                  deptName=this.deptNameList[n].name;
                }
              }
            }
            let time=parseInt(statusChangeTime[i])+1;
            if(status=="离线"){
              time="";
            }
            let param={
              id:"data"+i,
              status:status,
              statusId:agentStatus[i],
              agentNum:agentNums[i],
              employeeName:agentNames[i],
              time:time,
              deptName:deptName,
            };
            if(agentNums[i]!=this.loginName){
              if(!this.agentStatus){
                infoTableList.push(param);
                allTableList.push(param);
              }else {
                if(this.agentStatus==agentStatus[i]){
                  infoTableList.push(param);
                  allTableList.push(param);
                }
              }
            }
          }
          for (let m=0;m<allTableList.length;m++){
            let status=allTableList[m].status;
            let agentNum=allTableList[m].agentNum;
            for (let n=0;n<this.allTableList.length;n++){
              let oldNum=this.allTableList[n].agentNum;
              let oldStatus=this.allTableList[n].status;
              if(agentNum==oldNum && status==oldStatus){
                infoTableList[m].time=this.allTableList[n].time;
                allTableList[m].time=this.allTableList[n].time;
              }
            }
          }
          this.infoTableList=infoTableList;
          this.allTableList=allTableList;
        }
        if(infoTableList.length==0){
          let statusSet=['0','0','0','0','0']
          this.initEChart(statusSet);
          this.infoTableList=[];
          this.allTableList=[];
          return false;
        }
        let statusSet = this.stateSum(agentStatus);
        let isAll0 = true;
        for(let x = 0; x<statusSet.length; x++){
          if('0' != statusSet[x]){
            isAll0 = false;
          }
        }
        if(isAll0){
          return false;
        }
        this.initEChart(statusSet);
        let that=this;
        let count=0;
        for (let m=0;m<allTableList.length;m++) {
          let status = allTableList[m].status;
          let id = allTableList[m].id;
          let agentNum = allTableList[m].agentNum;
          if (this.selectedNum && agentNum == this.selectedNum) {
            setTimeout(function () {
              that.setSelected(id,agentNum,status);
            },1000);
            count++;
          }
        }
        if(count==0){
          this.setSelected("00","00","-1");
        }
      },
      initEChart:function(statusSet){
        let myChart = this.$echarts.init(document.getElementById('showDashboard'));
        myChart.setOption({
          title : {
            text: '座席状态图表',
            x:'center'
          },
          tooltip : {
            trigger: 'item',
            formatter: "{a} <br/>{b} : {c} ({d}%)"
          },
          legend: {
            orient: 'vertical',
            left: 'right',
            data: ['通话中','空闲','忙碌','离线','其它']
          },
          series : [
            {
              name: '座席状态',
              type: 'pie',
              radius : '55%',
              center: ['50%', '60%'],
              data:[
                {value:statusSet[2], name:'通话中'},
                {value:statusSet[1], name:'空闲'},
                {value:statusSet[3], name:'忙碌'},
                {value:statusSet[0], name:'离线'},
                {value:statusSet[4], name:'其它'},
              ],
              itemStyle: {
                emphasis: {
                  shadowBlur: 10,
                  shadowOffsetX: 0,
                  shadowColor: 'rgba(0, 0, 0, 0.5)'
                }
              }
            }
          ],
          color:['#da492c','#089708','#d78208','#1271c1','#f66bbf'],
        });
      },
      sortStatus:function(agentNames,agentNums,agentGroupNums,agentStatus,statusChangeTime){
        let status =['2','0','6','-1',''];  //排列顺序：通话中，空闲，忙碌，离线，其他
        let agentNames2 =[];
        let agentNums2 =[];
        let agentGroupNums2 = [];
        let agentStatus2 =[];
        let statusChangeTime2 =[];
        for(let n =0,len = status.length ;n < len; n++){
          let type = status[n];
          for(let m = 0,len = agentStatus.length; m < len; m++){
            let stat = agentStatus[m];
            if(this.loginName!=agentNums[m]){
              if(type === stat){
                agentNames2.push(agentNames[m]);
                agentNums2.push(agentNums[m]);
                agentGroupNums2.push(agentGroupNums[m]);
                agentStatus2.push(stat);
                statusChangeTime2.push(statusChangeTime[m]);
              }else if(n === 4 && stat != '2' && stat != '0' && stat != '6' && stat != '-1'){
                agentNames2.push(agentNames[m]);
                agentNums2.push(agentNums[m]);
                agentGroupNums2.push(agentGroupNums[m]);
                agentStatus2.push(stat);
                statusChangeTime2.push(statusChangeTime[m]);
              }
            }
          }
        }
        return [agentNames2,agentNums2,agentGroupNums2,agentStatus2,statusChangeTime2];
      },
      //计算座席状态个数
      stateSum:function(agentStatus){
        let stateNum = new Array(5);
        let num1 = 0;
        let num0 = 0;
        let num2 = 0;
        let num6 = 0;
        let otherNum = 0;
        for(let i=0,len = agentStatus.length; i < len; i++){
          if(agentStatus[i] === '-1'){
            num1++;
          }else if(agentStatus[i] === '0'){
            num0++;
          }else if(agentStatus[i] === '2'){
            num2++;
          }else if(agentStatus[i] === '6'){
            num6++;
          }else{
            otherNum++;
          }
        }
        stateNum[0] = num1;
        stateNum[1] = num0;
        stateNum[2] = num2;
        stateNum[3] = num6;
        stateNum[4] = otherNum;
        return stateNum;
      },
      //设备树初始化
      initSeatGroupTree:function (deptList,queueList) {
        let allNums = "";
      
        for (let i=0;i<deptList.length;i++){
          let name=deptList[i].name;
          let num=deptList[i].value;
          let pid=deptList[i].pid;
          let ID = deptList[i].id;
          let treeStr={
            id:ID,
            pId:pid,
            name:name,
            open:false,
            isParent:false,
            busid:num
          };
          this.inspectTreeData.push(treeStr);
          allNums += (num+",");
        }
        for (let i=0;i<queueList.length;i++){
          let name=queueList[i].name;
          let num=queueList[i].value;
          let treeStr={
            id:-2,
            pId:-1,
            name:name,
            open:false,
            isParent:false,
            busid:num
          };
          this.inspectTreeData.push(treeStr);
          allNums += (num+",");
        }
        this.currentBusid = allNums.substring(0,allNums.lastIndexOf(','));
        let that=this;
        let setting = {
          view: {
            dblClickExpand: false,
            showLine: true,
            selectedMulti: false
          },
          data: {
            simpleData: {
              enable:true,
              idKey: "id",
              pIdKey: "pId",
              rootPId: ""
            }
          },
          callback: {
            onClick: zTreeOnClick
          }
        };
        function zTreeOnClick(event,treeId,treeNode) {
          if(treeNode.busid!=-1){
            if(!treeNode.busid){
              that.$Message.info("该监控下,没有数据");
              let statusSet=['0','0','0','0','0'];
              that.initEChart(statusSet);
              that.infoTableList=[];
              that.allTableList=[];
              return false;
            }
            that.currentBusid=treeNode.busid;
            that.$emit("getSeat","get_agents_monitor_info","queueNumLstStr",treeNode.busid);
            clearInterval(that.timeMount);
            that.getTime();
          }else{
            // 点击部门和技能组查询对应的全部
            let list = [];
            if(treeNode.name === '部门'){
              list = that.deptListInit;
            }else if(treeNode.name === '技能组'){
              list = that.queueListInit;
            }else{
              return ;
            }
            let nums = "";
            for (let i=0;i<list.length;i++){
              nums += (list[i].value+",");
            }
            that.currentBusid = nums.substring(0,nums.lastIndexOf(','));
            that.$emit("getSeat","get_agents_monitor_info","queueNumLstStr",that.currentBusid);
          }
        }
        let zNodes =this.inspectTreeData;
        if (zNodes){
          $(document).ready(function(){
            $.fn.zTree.init($("#seatTree"), setting, zNodes);//t:用于展现 zTree 的 DOM 容器,setting:zTree 的配置数据,zNodes:zTree 的节点数据
          });
        }
      },
      monitorSeatData:function (event) {
        let retCode=event.retCode;
        if(retCode!='0'){
          this.$Message.info(event.reason);
          return false;
        }
        let eventMethod=event.method;
        if(eventMethod=="get_agents_monitor_info"){//获取技能组监控信息
          this.initSearch(event);
        }
      }
    },
    created(){
      this.force_offline=true;
      this.force_busy=true;
      this.force_idle=true;
      this.force_hangup=true;
      this.bargein=true;
      this.whisper=true;
      this.eavesdrop=true;
      this.screenHeight.height=this.mountHeight(92);
      let clientHeight=(document.documentElement.clientHeight-92)*0.6-130;
      this.tableHeight.height=clientHeight+'px';
      let signinStatus=localStorage.getItem("signinStatus");
      if(signinStatus=='0'){
        this.$Message.info("请先签入,再查询数据");
        return false;
      }
      let that=this;
      let param={
        journalType:"null",
        menuId:"null"
      };
      this.spinShow=true;
      this.$http.post("monitor/toRightRang.json",param) .then(function (res) {
        let result = res.data.flag;
        that.spinShow=false;
        if (result != "666") {
          that.$Message.info(res.data.msg);
          return false;
        }
        let deptList=res.data.obj.deptList;
        that.deptNameList=res.data.obj.deptNameList;
        let queueList=res.data.obj.skillList;
        that.fatherId=res.data.obj.fatherId;
        if(that.fatherId){
            that.inspectTreeData=[{"id":that.fatherId,"pId":0,"name":"部门","open":true,"isParent":true,"busid":"-1"},{"id":-1,"pId":-1,"name":"技能组","open":true,"isParent":true,"busid":"-1"}]
        }
        that.deptListInit = deptList;
        that.queueListInit = queueList;
        that.initSeatGroupTree(deptList,queueList);
      })
    },
    destroyed(){
      clearInterval(this.Interval);
      clearInterval(this.timeMount);
      this.autoRefreshTime="0";
      this.autoRefreshMonitor();
    },
    watch:{
      pageCode:function () {
        if(this.pageCode=='7_2-4' && this.showPageCount==0){
          this.showPageCount++;
          this.initSearch();
        }
        if(this.pageCode=='7_2-4'){
          this.autoRefreshTime=this.historyRefreshTime;
          this.autoRefreshMonitor();
        }
        if(this.pageCode!='7_2-4'){
          clearInterval(this.Interval);
          this.autoRefreshTime="0";
          this.countdownTime="0";
        }
      }
    }
  }
</script>

<style scoped>
  .demo-split{
    height: 100%;
    border: 1px solid #dcdee2;
  }
  .demo-split-pane{
    height: 100%;
    padding: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/components/MonitorManage/SeatMonitor.vue